import { EllipsisIcon } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "../Base/Popover";
import { Button } from "../Base/Button";
import { useState } from "react";
import { cn } from "@/lib/utils";
import { ClassNameValue } from "tailwind-merge";

interface ContainerMenuProps {
  containerId: string;
  removeItem: (id: string) => void;
  onEdit: () => void;
  triggerClassName?: ClassNameValue;
}
export const ContainerMenu = ({
  containerId,
  removeItem,
  onEdit,
  triggerClassName,
}: ContainerMenuProps) => {
  const [open, setOpen] = useState(false);

  const handleRemoveItem = () => {
    removeItem(containerId);
    setOpen(false);
  };

  const handleEdit = () => {
    onEdit();
    setOpen(false);
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger
        className={cn(
          "z-5 absolute right-1 top-0 cursor-pointer rounded-lg p-2 text-slate-300",
          triggerClassName
        )}
        onMouseDown={(e) => e.stopPropagation()}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <EllipsisIcon />
      </PopoverTrigger>
      <PopoverContent onMouseDown={(e) => e.stopPropagation()} className="w-72">
        <div className="flex w-full flex-col gap-2">
          <Button onClick={handleRemoveItem}>Remove Container</Button>
          <Button onClick={handleEdit}>Edit</Button>
        </div>
      </PopoverContent>
    </Popover>
  );
};
